<template>
  <v-sheet color="#C8E6C9">
    <base-section
      :height="$vuetify.breakpoint.mdAndUp ? '300px' : '150px'"
      id="contact-us"
      space="40"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="10" sm="10">
            <!-- <base-title
              class="white--text mr-9 text-lg-h3"
              :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
              color="white"
              title="Save an estimated 350 kg of C02 from listing a laptop for rent.
                This is the equivalent of driving 1255 km!"
            /> -->

            <base-body space="0">
              <span class=" text-sm-h6 text-lg-h4 black--text">
                Save an estimated 350 kg of C02 from listing a laptop for rent.
                This is the equivalent of driving 1255 km!
              </span>
            </base-body>
          </v-col>

          <v-col cols="12" sm="2">
            <v-img
              class="mt-n16 hidden-sm-and-down"
              :src="require('@/assets/svgs/grow-2.svg')"
            >
            </v-img>
            <!-- <base-btn
              :block="$vuetify.breakpoint.smAndDown"
              color="white"
              href="mailto:shop@vuetifyjs.com?subject=Zero%20Theme%20Question"
              large
              outlined
              target="_blank"
            >
              Contact Us
            </base-btn> -->
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-sheet>
</template>

<script>
export default {
  name: "Trees"
};
</script>

<style>
#contact-us {
  /* background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center; */
  /* background-color: #66bb6a; */
  background-image: #66bb6a;
  /* background-image: url("~@/assets/trees2.jpeg"); */
}
</style>
